export type Rank = { tier: number; name: string; clarity: number };

/** Each gap is ~30-40% longer than the last: front-loaded wins, then
    meaningful climbs, never a wall. Tier 12 is the last named rank —
    beyond it, prestige stars repeat every PRESTIGE_STEP Clarity. */
export const RANKS: Rank[] = [
  { tier: 1, name: "Whisper", clarity: 0 },
  { tier: 2, name: "Murmur", clarity: 150 },
  { tier: 3, name: "Cadence", clarity: 400 },
  { tier: 4, name: "Timbre", clarity: 800 },
  { tier: 5, name: "Projection", clarity: 1400 },
  { tier: 6, name: "Resonance", clarity: 2300 },
  { tier: 7, name: "Clarion", clarity: 3600 },
  { tier: 8, name: "Presence", clarity: 5400 },
  { tier: 9, name: "Orator", clarity: 7800 },
  { tier: 10, name: "Virtuoso", clarity: 11000 },
  { tier: 11, name: "Laureate", clarity: 15000 },
  { tier: 12, name: "Golden Voice", clarity: 20000 },
];

export const MAX_RANK_TIER = RANKS.length;
export const PRESTIGE_NAME = "Golden Voice";
export const PRESTIGE_STEP = 8000;
